import { t } from "@lingui/macro";
import React from "react";
import { G, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FlagIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Flag`} {...props}>
    <G>
      <Path
        d="M5.34375 13L4.22283 9.07143M4.22283 9.07143L3 4.78571C3 4.78571 3.23408 4.07143 4.40625 3.83333C6.31029 3.44658 7.375 4.84524 9.09375 4.25C10.5709 3.73844 11.4375 3 11.4375 3L13 8C13 8 12.0625 8.83333 10.6562 9.07143C9.07141 9.33976 8.42067 8.29762 6.07692 8.71429L4.22283 9.07143Z"
        stroke={"currentColor"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M4.5 9L3.5 5V4.5L5.5 4H9L11 3L13 7.5L12.5 8.5L10 9H4.5Z"
        fill={"currentColor"}
      />
    </G>
  </Icon>
);
